const texts = {
    noCuil:'EF0034: Tu perfil no tiene cargado un CUIL. No vas a poder firmar documentos hasta que tu identidad y datos sean validados por la autoridad correspondiente. Escribí a soporte para más información.',
  };
  
  export default texts;